'use es6';

import { fromJS, List, Map as ImmutableMap, OrderedMap, OrderedSet } from 'immutable';
import { sortData } from '../field/sort';
const round = (n, places) => {
  const x = Math.pow(10, places);
  return Math.round(n * x) / x;
};
const sum = (row, preceding, field, as) => row.set(as, round((row.get(field) || 0) + preceding.getIn([-1, 'accumulated', as], 0), 2));
function densify(data, groupBy, alongField) {
  const {
    domainWithGroups,
    groups
  } = data.reduce((acc, row) => {
    const domainValue = row.get(alongField);
    const group = List(groupBy.map(groupColumn => row.get(groupColumn)));
    return {
      domainWithGroups: acc.domainWithGroups.has(domainValue) ? acc.domainWithGroups.update(domainValue, domainGroups => domainGroups.set(group, row)) : acc.domainWithGroups.set(domainValue, ImmutableMap().set(group, row)),
      groups: acc.groups.has(group) ? acc.groups : acc.groups.add(group)
    };
  }, {
    domainWithGroups: OrderedMap(),
    groups: OrderedSet()
  });
  const generateEmptyRow = (domainValue, group) => fromJS(Object.assign({
    [alongField]: domainValue
  }, groupBy.reduce((acc, field, index) => Object.assign({}, acc, {
    [field]: group.get(index)
  }), {})));
  return domainWithGroups.map((rowsByGroup, domainValue) => groups.map(group => rowsByGroup.get(group) || generateEmptyRow(domainValue, group)).toList()).toList().flatten(1);
}
function accumulate(data, {
  groupBy,
  field,
  as,
  along
}) {
  if (along) {
    data = sortData(data, along.field, {
      direction: along.direction
    });
    data = groupBy.length > 0 ? densify(data, groupBy, along.field) : data;
  }
  return data.reduce(({
    result,
    memo
  }, row) => {
    const grouping = groupBy.map(groupColumn => row.get(groupColumn));
    const preceding = memo.getIn(grouping, List());
    const accumulatedRow = sum(row, preceding, field, as);
    return {
      result: result.push(accumulatedRow),
      memo: memo.setIn(grouping, preceding.push(fromJS({
        raw: row,
        accumulated: accumulatedRow
      })))
    };
  }, {
    result: List(),
    memo: groupBy.length > 0 ? ImmutableMap() : List()
  }).result;
}
export default ((dataset, {
  groupBy = [],
  field = '',
  as,
  along
}) => {
  return dataset.update('data', data => accumulate(data, {
    groupBy,
    field,
    as: as || field,
    along
  }));
});